// extracted by mini-css-extract-plugin
export default {"card":"s5-z"};